// tslint:disable:no-var-requires

import * as angular from 'angular';

// This module should have no dependencies on other modules

import UIGridHeaderCellHtml from './uiGridHeaderCellHtml.constant';

import ComponentsModule from './components/components.module';
import FormatModule from './format/format.module';
import LayoutModule from './layout/layout.module';
import StyleguideModule from './styleguide/styleguide.module';
import UtilModule from './util/util.module';
import ValidationModule from './validation/validation.module';
import AptitudeModule from './aptitude/aptitude.module';
import HttpInterceptorModule from './httpInterceptor.module';
import * as moment from 'moment-timezone';

export default angular
  .module('core', [
    AptitudeModule,
    HttpInterceptorModule,
    ComponentsModule,
    FormatModule,
    LayoutModule,
    StyleguideModule,
    UtilModule,
    ValidationModule,
  ])
  .constant('headerCellTemplate', UIGridHeaderCellHtml)
  .config([
    '$provide',
    ($provide) => {
      $provide.decorator('dateFilter', [
        '$delegate',
        '$injector',
        ($delegate, $injector) => {
          var oldDelegate = $delegate;

          var standardDateFilterInterceptor = (date, format, timezone) => {
            let DEFAULT_TIMEZONE = moment(date)
              .tz('America/Chicago')
              .format('z');

            if (angular.isUndefined(timezone)) {
              timezone = DEFAULT_TIMEZONE;
            }

            return oldDelegate.apply(this, [date, format, timezone]);
          };

          return standardDateFilterInterceptor;
        },
      ]);
    },
  ]).name;
